import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
declare var bootbox: any;

@Injectable()
export class ErrorsInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(event=> {

      }, error => {
        if (error instanceof HttpErrorResponse) {
          let httpError = error; 
          
          if (error.status == 500) {
            // Ne gérer que les erreurs 500
            let message:string = error.message;
            if (httpError.error.ExceptionMessage) {
              message = httpError.error.ExceptionMessage;
            }

            bootbox.alert(message);
            
          // } else if (error.status == 401) {
          //   bootbox.alert("Vous ne semblez plus authentifié !");
          }
        }
      })
      );
  }
}
